import React from 'react';

export default function RightArrow() {
  return (
    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.64123 4.27252C9.46961 4.10243 9.19261 4.10366 9.02252 4.27528C8.85243 4.44689 8.85366 4.7239 9.02528 4.89399L10.0537 5.91325C10.471 6.32692 10.7573 6.61161 10.9511 6.85283C11.014 6.93122 11.0632 7.00024 11.1013 7.06242L2.33325 7.06242C2.09163 7.06242 1.89575 7.2583 1.89575 7.49992C1.89575 7.74154 2.09163 7.93742 2.33325 7.93742L11.1013 7.93742C11.0632 7.9996 11.014 8.06861 10.9511 8.14701C10.7573 8.38823 10.471 8.67292 10.0537 9.08659L9.02528 10.1058C8.85366 10.2759 8.85243 10.5529 9.02252 10.7246C9.19261 10.8962 9.46961 10.8974 9.64123 10.7273L10.6882 9.68969C11.0825 9.29889 11.4048 8.97949 11.6333 8.6949C11.871 8.39896 12.043 8.09858 12.089 7.73801C12.099 7.65896 12.1041 7.57944 12.1041 7.49992C12.1041 7.4204 12.099 7.34087 12.089 7.26182C12.043 6.90126 11.871 6.60088 11.6333 6.30494C11.4047 6.02034 11.0825 5.70094 10.6881 5.31014L9.64123 4.27252Z"
        fill="#FAFAFA"
      />
    </svg>
  );
}
